import React from "react";
import styles from "../../components/Report/ReportGraph.module.css";
import { Line } from "react-chartjs-2";

import { IBillingCycleData } from "../../hooks/patients/useFetchBillingCyclePdf";

interface Props {
  children?: React.ReactNode;
  title?: string;
  billingCycleData: IBillingCycleData | null;
  sideEffectQuestions: {
    _id: string;
    billedCycle: string;
    sideEffect: string[];
    text: string;
  }[];
  customWidth?: string;
  customHeight?: string;
  graphs: {
    title: string;
    data: any;
    loading: boolean;
    color: string;
  }[];
  customStyle?: React.CSSProperties;
  contentStyle?: React.CSSProperties;
  cardStyle?: React.CSSProperties;
}

const NewReportGraph = ({
  billingCycleData,
  customWidth,
  customHeight,
  customStyle,
  contentStyle,
  graphs,
  cardStyle,
}: Props) => {
  return (
    <div
      className={`${styles.page} page-break`}
      style={{
        width: customWidth,
        height: customHeight,
      }}
    >
      <div className={styles.content} style={contentStyle}>
        <div className={styles.contentWrapper}>
          {graphs.map((graph, index) => (
            <div
              key={index}
              className={styles.graphContainer}
              style={cardStyle}
            >
              <h4 className={styles.graphTitle}>{graph.title}</h4>
              <div className={styles.graphContent}>
                {graph.loading ? (
                  <div className={styles.loadingContainer}>
                    Loading graph...
                  </div>
                ) : graph.data ? (
                  <div className={styles.chartWrapper}>
                    <Line
                      data={graph.data.data}
                      options={{
                        ...(graph.data as any).options,
                        maintainAspectRatio: false,
                        layout: { padding: 10 },
                        plugins: {
                          ...(graph.data as any).options?.plugins,
                          title: { display: false, text: "" },
                          legend: {
                            display: false,
                          },
                        },
                        scales: {
                          ...(graph.data as any).options?.scales,
                          y: {
                            ...(graph.data as any).options?.scales?.y,
                            min: 0,
                            max: 10,
                          },
                        },
                      }}
                    />
                  </div>
                ) : (
                  <div className={styles.noDataContainer}>
                    No data available
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NewReportGraph;
